import styled from 'styled-components'
import { colors } from 'ThemeStyle'

export const QuestionWrapper = styled.div`
  padding: 30px;

  @media (max-width: 700px) {
    padding: 12px;
  }
`

export const QuestionInfo = styled.div`
  display: grid;
  grid-template-columns: 300px auto;
  gap: 10px;
  padding: 6px 0;
  border-bottom: 1px solid rgba(224, 224, 224, 1);

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
    gap: 4px;
  }
`

export const Title = styled.div`
  font-weight: 500;
  color: ${colors.dark};
`
